class ProductBlockBScroller {
  constructor(container) {
    this.container = container;
    this.scrollContainer = container.querySelector('.product-block-b__media-grid');
    
    if (!this.scrollContainer) return;
    
    this.isDragging = false;
    this.startX = 0;
    this.scrollLeft = 0;
    
    this.init();
    
    // Wait for images to load before updating arrow visibility
    this.waitForImagesAndUpdateArrows();
  }
  
  init() {
    // Mouse events
    this.scrollContainer.addEventListener('mousedown', this.handleMouseDown.bind(this));
    this.scrollContainer.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    this.scrollContainer.addEventListener('mouseup', this.handleMouseUp.bind(this));
    this.scrollContainer.addEventListener('mousemove', this.handleMouseMove.bind(this));
    
    // Touch events
    this.scrollContainer.addEventListener('touchstart', this.handleTouchStart.bind(this));
    this.scrollContainer.addEventListener('touchend', this.handleTouchEnd.bind(this));
    this.scrollContainer.addEventListener('touchmove', this.handleTouchMove.bind(this));
    
    // Slider navigation events
    this.prevBtn = this.container.querySelector('button[name="prev"]');
    this.nextBtn = this.container.querySelector('button[name="next"]');
    
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', this.handlePrevClick.bind(this));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', this.handleNextClick.bind(this));
    }
    
    // Scroll event listener to update arrow visibility
    this.scrollContainer.addEventListener('scroll', this.updateArrowVisibility.bind(this));
    
    // Resize event listener to update arrow visibility when container size changes
    window.addEventListener('resize', this.updateArrowVisibility.bind(this));
    
    // Prevent default drag behavior on images
    this.scrollContainer.addEventListener('dragstart', (e) => e.preventDefault());
  }
  
  handleMouseDown(e) {
    this.isDragging = true;
    this.scrollContainer.classList.add('product-block-b__media-grid--dragging');
    this.startX = e.pageX - this.scrollContainer.offsetLeft;
    this.scrollLeft = this.scrollContainer.scrollLeft;
  }
  
  handleMouseLeave() {
    this.isDragging = false;
    this.scrollContainer.classList.remove('product-block-b__media-grid--dragging');
  }
  
  handleMouseUp() {
    this.isDragging = false;
    this.scrollContainer.classList.remove('product-block-b__media-grid--dragging');
  }
  
  handleMouseMove(e) {
    if (!this.isDragging) return;
    e.preventDefault();
    const x = e.pageX - this.scrollContainer.offsetLeft;
    const walk = (x - this.startX) * 2; // Scroll speed multiplier
    this.scrollContainer.scrollLeft = this.scrollLeft - walk;
  }
  
  handleTouchStart(e) {
    this.isDragging = true;
    this.startX = e.touches[0].pageX - this.scrollContainer.offsetLeft;
    this.scrollLeft = this.scrollContainer.scrollLeft;
  }
  
  handleTouchEnd() {
    this.isDragging = false;
  }
  
  handleTouchMove(e) {
    if (!this.isDragging) return;
    const x = e.touches[0].pageX - this.scrollContainer.offsetLeft;
    const walk = (x - this.startX) * 2;
    this.scrollContainer.scrollLeft = this.scrollLeft - walk;
  }
  
  handlePrevClick(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const scrollAmount = this.scrollContainer.clientWidth * 0.8;
    this.scrollContainer.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
    
    // Update arrow visibility after a short delay to allow smooth scroll to complete
    setTimeout(() => this.updateArrowVisibility(), 100);
  }
  
  handleNextClick(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const scrollAmount = this.scrollContainer.clientWidth * 0.8;
    this.scrollContainer.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
    
    // Update arrow visibility after a short delay to allow smooth scroll to complete
    setTimeout(() => this.updateArrowVisibility(), 100);
  }
  
  waitForImagesAndUpdateArrows() {
    // Wait for images to load
    const images = this.scrollContainer.querySelectorAll('img');
    let loadedImages = 0;
    
    if (images.length === 0) {
      // No images, update immediately
      setTimeout(() => this.updateArrowVisibility(), 100);
      return;
    }
    
    const checkAllImagesLoaded = () => {
      loadedImages++;
      if (loadedImages === images.length) {
        // All images loaded, update arrow visibility
        setTimeout(() => this.updateArrowVisibility(), 100);
      }
    };
    
    images.forEach(img => {
      if (img.complete) {
        checkAllImagesLoaded();
      } else {
        img.addEventListener('load', checkAllImagesLoaded);
        img.addEventListener('error', checkAllImagesLoaded); // Also count errors as "loaded"
      }
    });
    
    // Fallback: update after 1 second regardless
    setTimeout(() => this.updateArrowVisibility(), 1000);
  }
  
  updateArrowVisibility() {
    if (!this.prevBtn || !this.nextBtn) return;
    
    const scrollLeft = this.scrollContainer.scrollLeft;
    const scrollWidth = this.scrollContainer.scrollWidth;
    const clientWidth = this.scrollContainer.clientWidth;
    
    // Check if container has proper dimensions
    if (scrollWidth <= clientWidth) {
      // Content fits in container, hide both arrows
      this.prevBtn.style.display = 'none';
      this.nextBtn.style.display = 'none';
      return;
    }
    
    // Show/hide prev button based on scroll position
    if (scrollLeft <= 0) {
      this.prevBtn.style.display = 'none';
    } else {
      this.prevBtn.style.display = 'flex';
    }
    
    // Show/hide next button based on scroll position
    if (scrollLeft >= scrollWidth - clientWidth - 1) { // -1 for rounding errors
      this.nextBtn.style.display = 'none';
    } else {
      this.nextBtn.style.display = 'flex';
    }
  }
  
}

// Initialize all product block B scrollers
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.product-block-b');
  containers.forEach(container => new ProductBlockBScroller(container));
});
